var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43209"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 105",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "rotate(-180 14 14)",
    fill: "#F3223C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 7L10 14L17 21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseSidebarIcon);
export default __webpack_public_path__ + "static/media/collapseSidebarIcon.3dc8d1dcf42ef2217b220eba30003b44.svg";
export { ForwardRef as ReactComponent };